import React from 'react'
import {Section} from '../styles/AboutStyles'
import {Container, Title, Year, List, ListItem} from '../styles/AchievementsStyle'

const Achievements = () => {
  return (
    <Section>
      <Container>
        <Title>Achievements</Title>
        <Year>2024</Year>
        <List> 
            <ListItem>Sophia Matthew Group recognized as a San Francisco Business Journal Leader of Excellence</ListItem>
            <ListItem>Sophia Matthew Group included in San Francisco Business Journal's "Top 50" List of Real Estate Influencers</ListItem>
            <ListItem>The Sophia Matthew Group Team ranked #3 nationwide for sales production at Compass Realty</ListItem>
            <ListItem>San Francisco Magazine names Sophia Matthew Group a 2024 Real Estate Power Team</ListItem>
        </List>

        <Year>2023</Year>
        <List> 
            <ListItem>Sophia Matthew is one of the top 100 sales associates at Compass nationwide for Q3 2023</ListItem>
            <ListItem>REAL Trends recognizes the Sophia Matthew Group as one of America's Best Small Teams by Sales Volume</ListItem>
            <ListItem>Sophia Matthew is one of the top 100 sales associates at Compass nationwide for Q2 2023</ListItem>
            <ListItem>Sophia Matthew is one of the top 100 sales associates at Compass nationwide for Q1 2023</ListItem>
        </List>

        <Year>2022</Year>
        <List> 
            <ListItem>San Francisco Magazine names Sophia Matthew a 2022 Real Estate All Star</ListItem>
            <ListItem>The Sophia Matthew Group is the top producing team by sales volume at Compass San Francisco</ListItem>
        </List>
      </Container>
    </Section>
  )
}

export default Achievements